// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-admin-page .header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  background: #0f172a;
  color: white;

  padding: 20px;
  border-radius: 12px;
}

.dashboard-admin-page .header h1 {
  margin: 0;
}

.dashboard-admin-page .header p {
  margin-top: 5px;
}

.dashboard-admin-page .header-icon {
  font-size: 40px;
}

.dashboard-admin-page .cards {
  display: grid;
  grid-template-columns:
    repeat(auto-fit, minmax(220px, 1fr));

  gap: 15px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.dashboard-admin-page .card {
    position: relative;
    padding: 20px;
    border-radius: 16px;
    color: white;
    overflow: hidden;
    transition: all .3s ease;
    box-shadow: 0 6px 20px rgba(0,0,0,.15);
}
.dashboard-admin-page .card:hover {
    transform: translateY(-8px);
}

.dashboard-admin-page .card h4 {
  margin: 0;
}

.dashboard-admin-page .card h2 {
  margin-top: 10px;
}
.dashboard-admin-page .blue {
    background: linear-gradient(135deg,#2563eb,#1d4ed8);
}

.dashboard-admin-page .purple {
    background: linear-gradient(135deg,#7c3aed,#9333ea);
}

.dashboard-admin-page .green {
    background: linear-gradient(135deg,#16a34a,#22c55e);
}

.dashboard-admin-page .cyan {
    background: linear-gradient(135deg,#0891b2,#06b6d4);
}

.dashboard-admin-page .orange {
    background: linear-gradient(135deg,#ea580c,#f97316);
}

.dashboard-admin-page .red {
    background: linear-gradient(135deg,#dc2626,#ef4444);
}

.dashboard-admin-page .table-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
}


/* ===========================
   GRID WRAPPER
=========================== */

.dashboard-admin-page .grid-container {
    background: #ffffff;
    padding: 15px;
    border-radius: 15px;
    box-shadow:
        0 4px 12px rgba(0, 0, 0, 0.08);
}

/* ===========================
   SEARCH
=========================== */

.dashboard-admin-page .grid-toolbar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 15px;
}

.dashboard-admin-page .search-box {
    width: 450px;
    padding: 10px 15px;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    outline: none;
    font-size: 14px;
    transition: all .3s;
    background: #eceff3;
    color: #000000;
}

.dashboard-admin-page .search-box:focus {
    border-color: #2563eb;
    box-shadow: 0 0 6px rgba(37, 99, 235, .4);
}

/* ===========================
   AG GRID
=========================== */

.dashboard-admin-page .ag-theme-alpine {

    --ag-font-size: 16px;

    --ag-header-height: 48px;

    --ag-header-background-color: #f4f8f4;

    --ag-header-foreground-color: rgb(243, 228, 228);

    --ag-row-hover-color: #dbeafe;

    --ag-selected-row-background-color: #bfdbfe;

    --ag-border-color: #d1d5db;

    --ag-odd-row-background-color: #ffffff;

    --ag-row-border-color: #e5e7eb;

    border-radius: 12px;

    overflow: hidden;
}

/* ===========================
   HEADER
=========================== */

.dashboard-admin-page .ag-theme-alpine .ag-header {
    border-bottom: 3px solid #2563eb;
}

.dashboard-admin-page .ag-theme-alpine .ag-header-cell-label {
    font-weight: 700;
    font-size: 16px;
}

/* ===========================
   ROWS
=========================== */

.dashboard-admin-page .ag-theme-alpine .ag-row:nth-child(even) {
    background-color: #f8fafc;
}

.dashboard-admin-page .ag-theme-alpine .ag-row:nth-child(odd) {
    background-color: #ffffff;
}

.dashboard-admin-page .ag-theme-alpine .ag-row:hover {
    background-color: #dbeafe !important;
    transition: all .2s;
}

/* ===========================
   FILTERS
=========================== */

.dashboard-admin-page .ag-theme-alpine .ag-floating-filter-input {
    border-radius: 12px;
}

.dashboard-admin-page .ag-theme-alpine .ag-floating-filter-body input {
    font-size: 12px;
    padding: 2px;
}

/* ===========================
   PAGINATION
=========================== */

.dashboard-admin-page .ag-theme-alpine .ag-paging-panel {
    background: #f8fafc;
    border-top: 1px solid #e5e7eb;
    min-height: 40px;
}

/* ===========================
   SCROLLBAR
=========================== */

.dashboard-admin-page .ag-theme-alpine .ag-body-horizontal-scroll::-webkit-scrollbar,
.dashboard-admin-page .ag-theme-alpine .ag-body-vertical-scroll::-webkit-scrollbar {
    height: 8px;
    width: 8px;
}

.dashboard-admin-page .ag-theme-alpine .ag-body-horizontal-scroll::-webkit-scrollbar-thumb,
.dashboard-admin-page .ag-theme-alpine .ag-body-vertical-scroll::-webkit-scrollbar-thumb {
    background: #94a3b8;
    border-radius: 20px;
}

/* ===========================
   STATUS BADGES
=========================== */

.dashboard-admin-page .status-yes {
    background: #16a34a;
    color: white;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
}

.dashboard-admin-page .status-no {
    background: #dc2626;
    color: white;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
}

/* ===========================
   TABLE TITLE
=========================== */

.dashboard-admin-page .table-title {
    font-size: 22px;
    font-weight: 800;
    color: #050d1e;
    margin-bottom: 15px;
}

/* ===========================
   RESPONSIVE
=========================== */

@media (max-width: 768px) {

    .dashboard-admin-page .search-box {
        width: 100%;
    }

    .dashboard-admin-page .grid-toolbar {
        justify-content: stretch;
    }
}


/* ===========================
   Excel EXPORT BUTTON
=========================== */
.dashboard-admin-page .export-btn{
    background:#2563eb;
    color:white;
    border:none;
    padding:10px 16px;
    border-radius:8px;
    cursor:pointer;
    margin-right:10px;
}

.dashboard-admin-page .export-btn:hover{
    background:#1d4ed8;
}


/* ===========================
   FLOATING FILTERS

=========================== */
.dashboard-admin-page .badge-green{
    background:#dcfce7;
    color:#15803d;
    padding:4px 10px;
    border-radius:20px;
    font-weight:600;
    font-size:12px;
}

.dashboard-admin-page .badge-red{
    background:#fee2e2;
    color:#b91c1c;
    padding:4px 10px;
    border-radius:20px;
    font-weight:600;
    font-size:12px;
}

.dashboard-admin-page .editing-row {
    background-color: #bca890 !important;
}
.dashboard-admin-page .edit-btn,
.dashboard-admin-page .update-btn,
.dashboard-admin-page .cancel-btn {
    min-width: 60px;
    min-height: 30px;
    vertical-align: top;   
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
     transition: all .3s ease;     
}
.dashboard-admin-page .edit-btn:hover {
    background: #3d86e0;
     transform: translateY(-2px);
}
.dashboard-admin-page .update-btn:hover {
    background: #15803d;
    transform: translateY(-2px);
}
.dashboard-admin-page .cancel-btn:hover {
    background: #b91c1c;
    transform: translateY(-1px);
}


.dashboard-admin-page .edit-btn {
    background: #02746b;
    color: #fff;
    border: none;
    padding: 8px 14px;
    border-radius: 6px;
    cursor: pointer;
}
.dashboard-admin-page .update-btn {
    background: #330bd4;
    color: #ddeae1;
    border: 1px solid #bbf7d0;
}

.dashboard-admin-page .cancel-btn {
    background: #c70303;
    color: #f4eded;
    border: 1px solid #fecaca;
}



.dashboard-admin-page .modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,.45);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.dashboard-admin-page .password-modal {
    width: 350px;
    background: white;
    border-radius: 12px;
    padding: 25px;
    box-shadow: 0 10px 30px rgba(0,0,0,.25);
}

.dashboard-admin-page .password-modal h3 {
    margin-bottom: 15px;
}

.dashboard-admin-page .password-modal input {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 6px;
    margin-bottom: 15px;
    box-sizing: border-box;
}

.dashboard-admin-page .modal-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.dashboard-admin-page .grid-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.dashboard-admin-page .search-box {
    width: 350px;
    padding: 10px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 14px;
}

.dashboard-admin-page .p-datatable {
    font-size: 14px;
}

.dashboard-admin-page .p-datatable .p-datatable-header {
    background: #02746b;
    color: white;
}

.dashboard-admin-page .p-datatable .p-datatable-thead > tr > th {
    background: #0f766e;
    color: white;
}


.dashboard-admin-page .password-input-wrapper {
    position: relative;
}

.dashboard-admin-page .password-input-wrapper input {
    width: 100%;
    padding: 10px 40px 10px 10px;
    box-sizing: border-box;
}

.dashboard-admin-page .password-eye {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/DasboardAdminCSS.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;EAEnB,mBAAmB;EACnB,YAAY;;EAEZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb;wCACsC;;EAEtC,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;IACxB,sCAAsC;AAC1C;AACA;IACI,2BAA2B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;AACA;IACI,mDAAmD;AACvD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;;6BAE6B;;AAE7B;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB;sCACkC;AACtC;;AAEA;;6BAE6B;;AAE7B;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA;;6BAE6B;;AAE7B;;IAEI,oBAAoB;;IAEpB,wBAAwB;;IAExB,qCAAqC;;IAErC,gDAAgD;;IAEhD,6BAA6B;;IAE7B,2CAA2C;;IAE3C,0BAA0B;;IAE1B,sCAAsC;;IAEtC,8BAA8B;;IAE9B,mBAAmB;;IAEnB,gBAAgB;AACpB;;AAEA;;6BAE6B;;AAE7B;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;6BAE6B;;AAE7B;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;;6BAE6B;;AAE7B;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;;6BAE6B;;AAE7B;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;;6BAE6B;;AAE7B;;IAEI,WAAW;IACX,UAAU;AACd;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;6BAE6B;;AAE7B;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;6BAE6B;;AAE7B;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;;6BAE6B;;AAE7B;;IAEI;QACI,WAAW;IACf;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;;AAGA;;6BAE6B;AAC7B;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;;;6BAG6B;AAC7B;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;AACA;;;IAGI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;KACd,wBAAwB;AAC7B;AACA;IACI,mBAAmB;KAClB,2BAA2B;AAChC;AACA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;;AAGA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;;;AAIA;IACI,eAAe;IACf,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB","sourcesContent":[".dashboard-admin-page .header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  background: #0f172a;\n  color: white;\n\n  padding: 20px;\n  border-radius: 12px;\n}\n\n.dashboard-admin-page .header h1 {\n  margin: 0;\n}\n\n.dashboard-admin-page .header p {\n  margin-top: 5px;\n}\n\n.dashboard-admin-page .header-icon {\n  font-size: 40px;\n}\n\n.dashboard-admin-page .cards {\n  display: grid;\n  grid-template-columns:\n    repeat(auto-fit, minmax(220px, 1fr));\n\n  gap: 15px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.dashboard-admin-page .card {\n    position: relative;\n    padding: 20px;\n    border-radius: 16px;\n    color: white;\n    overflow: hidden;\n    transition: all .3s ease;\n    box-shadow: 0 6px 20px rgba(0,0,0,.15);\n}\n.dashboard-admin-page .card:hover {\n    transform: translateY(-8px);\n}\n\n.dashboard-admin-page .card h4 {\n  margin: 0;\n}\n\n.dashboard-admin-page .card h2 {\n  margin-top: 10px;\n}\n.dashboard-admin-page .blue {\n    background: linear-gradient(135deg,#2563eb,#1d4ed8);\n}\n\n.dashboard-admin-page .purple {\n    background: linear-gradient(135deg,#7c3aed,#9333ea);\n}\n\n.dashboard-admin-page .green {\n    background: linear-gradient(135deg,#16a34a,#22c55e);\n}\n\n.dashboard-admin-page .cyan {\n    background: linear-gradient(135deg,#0891b2,#06b6d4);\n}\n\n.dashboard-admin-page .orange {\n    background: linear-gradient(135deg,#ea580c,#f97316);\n}\n\n.dashboard-admin-page .red {\n    background: linear-gradient(135deg,#dc2626,#ef4444);\n}\n\n.dashboard-admin-page .table-title {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n\n\n/* ===========================\n   GRID WRAPPER\n=========================== */\n\n.dashboard-admin-page .grid-container {\n    background: #ffffff;\n    padding: 15px;\n    border-radius: 15px;\n    box-shadow:\n        0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n/* ===========================\n   SEARCH\n=========================== */\n\n.dashboard-admin-page .grid-toolbar {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 15px;\n}\n\n.dashboard-admin-page .search-box {\n    width: 450px;\n    padding: 10px 15px;\n    border: 1px solid #cbd5e1;\n    border-radius: 8px;\n    outline: none;\n    font-size: 14px;\n    transition: all .3s;\n    background: #eceff3;\n    color: #000000;\n}\n\n.dashboard-admin-page .search-box:focus {\n    border-color: #2563eb;\n    box-shadow: 0 0 6px rgba(37, 99, 235, .4);\n}\n\n/* ===========================\n   AG GRID\n=========================== */\n\n.dashboard-admin-page .ag-theme-alpine {\n\n    --ag-font-size: 16px;\n\n    --ag-header-height: 48px;\n\n    --ag-header-background-color: #f4f8f4;\n\n    --ag-header-foreground-color: rgb(243, 228, 228);\n\n    --ag-row-hover-color: #dbeafe;\n\n    --ag-selected-row-background-color: #bfdbfe;\n\n    --ag-border-color: #d1d5db;\n\n    --ag-odd-row-background-color: #ffffff;\n\n    --ag-row-border-color: #e5e7eb;\n\n    border-radius: 12px;\n\n    overflow: hidden;\n}\n\n/* ===========================\n   HEADER\n=========================== */\n\n.dashboard-admin-page .ag-theme-alpine .ag-header {\n    border-bottom: 3px solid #2563eb;\n}\n\n.dashboard-admin-page .ag-theme-alpine .ag-header-cell-label {\n    font-weight: 700;\n    font-size: 16px;\n}\n\n/* ===========================\n   ROWS\n=========================== */\n\n.dashboard-admin-page .ag-theme-alpine .ag-row:nth-child(even) {\n    background-color: #f8fafc;\n}\n\n.dashboard-admin-page .ag-theme-alpine .ag-row:nth-child(odd) {\n    background-color: #ffffff;\n}\n\n.dashboard-admin-page .ag-theme-alpine .ag-row:hover {\n    background-color: #dbeafe !important;\n    transition: all .2s;\n}\n\n/* ===========================\n   FILTERS\n=========================== */\n\n.dashboard-admin-page .ag-theme-alpine .ag-floating-filter-input {\n    border-radius: 12px;\n}\n\n.dashboard-admin-page .ag-theme-alpine .ag-floating-filter-body input {\n    font-size: 12px;\n    padding: 2px;\n}\n\n/* ===========================\n   PAGINATION\n=========================== */\n\n.dashboard-admin-page .ag-theme-alpine .ag-paging-panel {\n    background: #f8fafc;\n    border-top: 1px solid #e5e7eb;\n    min-height: 40px;\n}\n\n/* ===========================\n   SCROLLBAR\n=========================== */\n\n.dashboard-admin-page .ag-theme-alpine .ag-body-horizontal-scroll::-webkit-scrollbar,\n.dashboard-admin-page .ag-theme-alpine .ag-body-vertical-scroll::-webkit-scrollbar {\n    height: 8px;\n    width: 8px;\n}\n\n.dashboard-admin-page .ag-theme-alpine .ag-body-horizontal-scroll::-webkit-scrollbar-thumb,\n.dashboard-admin-page .ag-theme-alpine .ag-body-vertical-scroll::-webkit-scrollbar-thumb {\n    background: #94a3b8;\n    border-radius: 20px;\n}\n\n/* ===========================\n   STATUS BADGES\n=========================== */\n\n.dashboard-admin-page .status-yes {\n    background: #16a34a;\n    color: white;\n    padding: 4px 10px;\n    border-radius: 20px;\n    font-size: 11px;\n    font-weight: 600;\n}\n\n.dashboard-admin-page .status-no {\n    background: #dc2626;\n    color: white;\n    padding: 4px 10px;\n    border-radius: 20px;\n    font-size: 11px;\n    font-weight: 600;\n}\n\n/* ===========================\n   TABLE TITLE\n=========================== */\n\n.dashboard-admin-page .table-title {\n    font-size: 22px;\n    font-weight: 800;\n    color: #050d1e;\n    margin-bottom: 15px;\n}\n\n/* ===========================\n   RESPONSIVE\n=========================== */\n\n@media (max-width: 768px) {\n\n    .dashboard-admin-page .search-box {\n        width: 100%;\n    }\n\n    .dashboard-admin-page .grid-toolbar {\n        justify-content: stretch;\n    }\n}\n\n\n/* ===========================\n   Excel EXPORT BUTTON\n=========================== */\n.dashboard-admin-page .export-btn{\n    background:#2563eb;\n    color:white;\n    border:none;\n    padding:10px 16px;\n    border-radius:8px;\n    cursor:pointer;\n    margin-right:10px;\n}\n\n.dashboard-admin-page .export-btn:hover{\n    background:#1d4ed8;\n}\n\n\n/* ===========================\n   FLOATING FILTERS\n\n=========================== */\n.dashboard-admin-page .badge-green{\n    background:#dcfce7;\n    color:#15803d;\n    padding:4px 10px;\n    border-radius:20px;\n    font-weight:600;\n    font-size:12px;\n}\n\n.dashboard-admin-page .badge-red{\n    background:#fee2e2;\n    color:#b91c1c;\n    padding:4px 10px;\n    border-radius:20px;\n    font-weight:600;\n    font-size:12px;\n}\n\n.dashboard-admin-page .editing-row {\n    background-color: #bca890 !important;\n}\n.dashboard-admin-page .edit-btn,\n.dashboard-admin-page .update-btn,\n.dashboard-admin-page .cancel-btn {\n    min-width: 60px;\n    min-height: 30px;\n    vertical-align: top;   \n    align-items: center;\n    justify-content: center;\n    border-radius: 8px;\n    cursor: pointer;\n     transition: all .3s ease;     \n}\n.dashboard-admin-page .edit-btn:hover {\n    background: #3d86e0;\n     transform: translateY(-2px);\n}\n.dashboard-admin-page .update-btn:hover {\n    background: #15803d;\n    transform: translateY(-2px);\n}\n.dashboard-admin-page .cancel-btn:hover {\n    background: #b91c1c;\n    transform: translateY(-1px);\n}\n\n\n.dashboard-admin-page .edit-btn {\n    background: #02746b;\n    color: #fff;\n    border: none;\n    padding: 8px 14px;\n    border-radius: 6px;\n    cursor: pointer;\n}\n.dashboard-admin-page .update-btn {\n    background: #330bd4;\n    color: #ddeae1;\n    border: 1px solid #bbf7d0;\n}\n\n.dashboard-admin-page .cancel-btn {\n    background: #c70303;\n    color: #f4eded;\n    border: 1px solid #fecaca;\n}\n\n\n\n.dashboard-admin-page .modal-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0,0,0,.45);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n}\n\n.dashboard-admin-page .password-modal {\n    width: 350px;\n    background: white;\n    border-radius: 12px;\n    padding: 25px;\n    box-shadow: 0 10px 30px rgba(0,0,0,.25);\n}\n\n.dashboard-admin-page .password-modal h3 {\n    margin-bottom: 15px;\n}\n\n.dashboard-admin-page .password-modal input {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    margin-bottom: 15px;\n    box-sizing: border-box;\n}\n\n.dashboard-admin-page .modal-buttons {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n}\n\n.dashboard-admin-page .grid-toolbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.dashboard-admin-page .search-box {\n    width: 350px;\n    padding: 10px;\n    border: 1px solid #d1d5db;\n    border-radius: 8px;\n    font-size: 14px;\n}\n\n.dashboard-admin-page .p-datatable {\n    font-size: 14px;\n}\n\n.dashboard-admin-page .p-datatable .p-datatable-header {\n    background: #02746b;\n    color: white;\n}\n\n.dashboard-admin-page .p-datatable .p-datatable-thead > tr > th {\n    background: #0f766e;\n    color: white;\n}\n\n\n.dashboard-admin-page .password-input-wrapper {\n    position: relative;\n}\n\n.dashboard-admin-page .password-input-wrapper input {\n    width: 100%;\n    padding: 10px 40px 10px 10px;\n    box-sizing: border-box;\n}\n\n.dashboard-admin-page .password-eye {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n    user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
